module.exports = __webpack_public_path__ + "img/upload.ca90b5f6.png";